module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-id-ID.9349687d.jpg";